module.exports = __webpack_public_path__ + "static/img/JGArchitecture_报账_image@2x.3fe9bb73.png";